module.exports = __webpack_public_path__ + "img/participation.1f8ccd0d.svg";